/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Birthday_Event_Ended_TitleInputs */

const en_birthday_event_ended_title = /** @type {(inputs: Birthday_Event_Ended_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That's a wrap on baking`)
};

const ar_birthday_event_ended_title = /** @type {(inputs: Birthday_Event_Ended_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خبز مكتمل`)
};

const de_birthday_event_ended_title = /** @type {(inputs: Birthday_Event_Ended_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backen abgeschlossen`)
};

const es_birthday_event_ended_title = /** @type {(inputs: Birthday_Event_Ended_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fin del horneado`)
};

const fr_birthday_event_ended_title = /** @type {(inputs: Birthday_Event_Ended_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuisson terminée`)
};

const it_birthday_event_ended_title = /** @type {(inputs: Birthday_Event_Ended_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cottura terminata`)
};

const ja_birthday_event_ended_title = /** @type {(inputs: Birthday_Event_Ended_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ベーキング終了`)
};

const ko_birthday_event_ended_title = /** @type {(inputs: Birthday_Event_Ended_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`베이킹 종료`)
};

const pt_br_birthday_event_ended_title = /** @type {(inputs: Birthday_Event_Ended_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fornada concluída`)
};

const ru_birthday_event_ended_title = /** @type {(inputs: Birthday_Event_Ended_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выпечка завершена`)
};

const th_birthday_event_ended_title = /** @type {(inputs: Birthday_Event_Ended_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อบเสร็จสิ้น`)
};

const tr_birthday_event_ended_title = /** @type {(inputs: Birthday_Event_Ended_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pişirme tamamlandı`)
};

const zh_cn_birthday_event_ended_title = /** @type {(inputs: Birthday_Event_Ended_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`烘焙结束`)
};

const zh_tw_birthday_event_ended_title = /** @type {(inputs: Birthday_Event_Ended_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`烘焙結束`)
};

/**
* | output |
* | --- |
* | "That's a wrap on baking" |
*
* @param {Birthday_Event_Ended_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const birthday_event_ended_title = /** @type {((inputs?: Birthday_Event_Ended_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Birthday_Event_Ended_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_birthday_event_ended_title(inputs)
	if (locale === "ar") return ar_birthday_event_ended_title(inputs)
	if (locale === "de") return de_birthday_event_ended_title(inputs)
	if (locale === "es") return es_birthday_event_ended_title(inputs)
	if (locale === "fr") return fr_birthday_event_ended_title(inputs)
	if (locale === "it") return it_birthday_event_ended_title(inputs)
	if (locale === "ja") return ja_birthday_event_ended_title(inputs)
	if (locale === "ko") return ko_birthday_event_ended_title(inputs)
	if (locale === "pt_br") return pt_br_birthday_event_ended_title(inputs)
	if (locale === "ru") return ru_birthday_event_ended_title(inputs)
	if (locale === "th") return th_birthday_event_ended_title(inputs)
	if (locale === "tr") return tr_birthday_event_ended_title(inputs)
	if (locale === "zh_cn") return zh_cn_birthday_event_ended_title(inputs)
	return zh_tw_birthday_event_ended_title(inputs)
});